'use client'

import { useEffect } from 'react'

import { Box, Button, Heading, Text } from '@chakra-ui/react'
import posthog from 'posthog-js'

export default function Error({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  useEffect(() => {
    try {
      posthog.captureException(error, {
        name: error.name ?? 'Unknown error',
        message: error.message ?? 'No message available',
        stack: error.stack ?? 'No stack trace available',
      })
    } catch (captureError) {
      console.error('Failed to capture error to PostHog', captureError)
    }
  }, [error])

  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      minH="100vh"
      p={6}
    >
      <Heading as="h2" color="red.500" mb={4} size="lg" textAlign="center">
        Something went wrong
      </Heading>
      <Text color="gray.700" maxW="2xl" mb={4} textAlign="center">
        The page hit an unexpected error and could not finish loading. Try again
        with the button below, or reload the page. If it keeps happening, share
        the technical details below with a developer.
      </Text>
      <Text color="gray.500" fontSize="sm" mb={2}>
        Technical details
      </Text>
      <Box
        bg="gray.50"
        borderColor="gray.200"
        borderRadius="md"
        borderWidth="1px"
        maxH="40vh"
        maxW="full"
        mb={6}
        overflow="auto"
        p={4}
        w="2xl"
      >
        <Text
          color="gray.700"
          fontFamily="mono"
          fontSize="sm"
          whiteSpace="pre-wrap"
          wordBreak="break-word"
        >
          {error?.message || 'No error message available'}
        </Text>
      </Box>
      <Button onClick={() => reset()}>Try again</Button>
    </Box>
  )
}
